export default {
  title: 'Nichts verpassen!',
  description: 'Aktivieren Sie Benachrichtigungen, um über Ihre Bestellung auf dem Laufenden zu bleiben.',
  buttons: {
    enable: 'Aktivieren',
  },
};
